import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ApiVisa, BaseApiTemplateService, BasicApiResponseModel} from '../../shared';
import {Core2Config} from '../../shared';
import {MofDocHdrContainerModel} from '../../../../../../models';
import {Observable} from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class MofDocHdrService extends BaseApiTemplateService<MofDocHdrContainerModel> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX +
    Core2Config.AAT_PREFIX + Core2Config.CLAIMS_PREFIX + 'mof-doc-hdrs/backoffice-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX +
      Core2Config.AAT_PREFIX + Core2Config.CLAIMS_PREFIX + 'mof-doc-hdrs/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
      Core2Config.CLAIMS_PREFIX + 'mof-doc-hdrs/backoffice-ep';
    this.httpClient = http;
  }

  createTempDocHdr(body: MofDocHdrContainerModel, visa: ApiVisa): Observable<BasicApiResponseModel<MofDocHdrContainerModel>> {
    let url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
      Core2Config.CLAIMS_PREFIX + 'mof-doc-hdrs/temp/backoffice-ep';
    if (visa.api_domain_url) {
      url = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
        Core2Config.CLAIMS_PREFIX + 'mof-doc-hdrs/temp/backoffice-ep';
    }
    return this.httpClient.post<BasicApiResponseModel<MofDocHdrContainerModel>>(url, body, this.getHttpHeader(visa));
  }

}


